import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionLabel = ({ children }) => (
  <p className="font-mono2 text-[11px] sm:text-xs tracking-[0.3em] uppercase text-[#FFE600] flex items-center gap-3">
    <span className="inline-block w-8 h-px bg-[#FFE600]" />
    {children}
  </p>
);
